module.exports = __webpack_public_path__ + "img/login_bluer.c2df6d05.png";